module.exports = __webpack_public_path__ + "static/howitworks_hero-030e5459cef4d677dda19d4aef13bbd6.png";